// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React from 'react';

import { componentFactory } from '@powdr/utils';

import { StyledGlobalContent } from './styles';

export const GlobalContent = ({
  relationships,
  parentColorProfile = null,
}) => {
  const contentNodes = relationships?.contentNodes?.filter((node) => node?.status !== false);

  if (contentNodes.length === 0) return null;

  return (
    <StyledGlobalContent>
      {componentFactory(contentNodes, parentColorProfile)}
    </StyledGlobalContent>
  );
};

GlobalContent.propTypes = {
  relationships: PropTypes.shape().isRequired,
  parentColorProfile: PropTypes.string,
};
